import { isHrFamilyRole } from "./hrStaffHelpers";

/** @returns {"OFFICE"|"REMOTE"|"HYBRID"} */
export function normalizeWorkMode(mode) {
  const value = String(mode || "OFFICE")
    .trim()
    .toUpperCase();
  if (value === "REMOTE" || value === "HYBRID" || value === "OFFICE") {
    return value;
  }
  return "OFFICE";
}

/** حضور وانصراف التطبيق: مختلط أو عن بُعد فقط (ليس مكتب/بصمة) */
export function canUseRemoteAttendance(workMode) {
  const mode = normalizeWorkMode(workMode);
  return mode === "REMOTE" || mode === "HYBRID";
}

/** طلب العمل عن بُعد: موظفو النظام المختلط فقط */
export function canRequestWfh(workMode) {
  return normalizeWorkMode(workMode) === "HYBRID";
}

export function canApproveWfh(userRole, backendRoles = []) {
  return (
    userRole === "manager" ||
    userRole === "department-manager" ||
    isHrFamilyRole(userRole) ||
    userRole === "gm" ||
    backendRoles.includes("manager") ||
    backendRoles.includes("branch_manager") ||
    backendRoles.includes("regional_manager") ||
    backendRoles.includes("department_manager") ||
    backendRoles.includes("hr") ||
    backendRoles.includes("hr_staff")
  );
}

/**
 * العمل عن بُعد في القائمة:
 * - موظف مختلط (لتقديم الطلب)
 * - أو مدير/HR للموافقة على طلبات الفريق
 */
export function canSeeWfhNav(workMode, userRole, backendRoles = []) {
  return canRequestWfh(workMode) || canApproveWfh(userRole, backendRoles);
}
